//Bundle Buying Option
export const DEFAULT_QUANTITY = 1;

export const VARIANT_BUNDLE_EVENT_KEY = 'VARIANT_BUNDLE_EVENT_KEY';

export const WARRANTY_BUNDLE_EVENT_KEY = 'WARRANTY_BUNDLE_EVENT_KEY';

export const FREEGIFT_BUNDLE_EVENT_KEY = 'FREEGIFT_BUNDLE_EVENT_KEY';

export const ADDITIONAL_OPTIONS_EVENT_KEY = 'ADDITIONAL_OPTIONS_EVENT_KEY';